import { ForwardedRef, forwardRef, memo, ReactNode } from 'react'

import { styled } from '@mui/material'
import { AnimatePresence, motion } from 'motion/react'

const Animator = styled(motion.div)({
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
})

type PanelAnimation = {
  children: ReactNode
  in?: boolean
  onEnter?: (node: ForwardedRef<HTMLDivElement>, isAppearing: boolean) => void
  onExited?: (node: ForwardedRef<HTMLDivElement>, isAppearing: boolean) => void
}

const PanelAnimationRaw = (
  { children, in: open, onEnter, onExited }: PanelAnimation,
  ref: ForwardedRef<HTMLDivElement>,
) => (
  <AnimatePresence onExitComplete={() => onExited?.(ref, true)}>
    {!!open && (
      <Animator
        ref={ref}
        key="foldout-animator"
        initial={{ opacity: 0, x: '100%' }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: '100%' }}
        onAnimationStart={() => onEnter?.(ref, true)}
      >
        {children}
      </Animator>
    )}
  </AnimatePresence>
)

export const PanelAnimation = memo(forwardRef(PanelAnimationRaw))
